module.exports = __webpack_public_path__ + "static/img/leetcode.535d17f3.jpg";